import enLocale from 'vant/es/locale/lang/en-US';

export const lang = {
  vant: enLocale,
  tjcg: 'Submitted successfully',
  gmcg: 'Purchase successful',
  ts: 'Notice',
  qrz: 'Go to verification',
  qx: 'Cancel',
  qxzwj: 'Please select a file',
  yjs: 'Finished',
  fl: 'Cat.',
  bkzh: 'Not exchangeable',
  yrz: 'Verified',
  kzh: 'Exchangeable',
  cpjs: 'Product description',
  xzrq: 'Select date',
  qd: 'Confirm',
  qxz: 'Please select',
  xlsx: 'Pull to refresh',
  zzsx: 'Refreshing',
  'zzsx...': 'Refreshing...',
  zzjz: 'Loading',
  'zzjz...': 'Loading...',
  ddl: 'Reached the end',
  jzgd: 'Load more',
  mygdl: 'No more data',
  sxcg: 'Refresh successful',
  sxsb: 'Refresh failed',
  gdz: 'Scrolling',
  ycd: 'Reached the bottom',
  xz: 'Select',
  zdxz: 'Select up to',
  x: 'items',
  qsr: 'Please enter',
  qzqtx: 'Please fill correctly',
  sj: 'Data',
  cxcxz: 'Choose from album',
  pz: 'Take photo',
  xzsp: 'Select video',
  qxzszdq: 'Please select your region',
  qscsphtp: 'Please upload video or image',
  wjdxbncg: 'File size cannot exceed',
  zzdkxj: 'Opening camera',
  pzcg: 'Photo taken successfully',
  pzsb: 'Photo failed',
  pzgccc: 'Error during photo capture',
  myxjqx: 'No camera permission',
  xyqx: 'Permission required',
  qyxyyfwxjyjxpz: 'Please allow the app to access the camera to take photos',
  zbjx: 'Ready',
  myzdxc: 'No album found',
  qxcjygxc: 'Please create an album first',
  tpybcdxc: 'Image saved to album',
  bcsb: 'Save failed',
  djck: 'Tap to view',
  tj: 'Add',
  tbz: 'Syncing',
  tbsb: 'Sync failed',
  ljz: 'Connecting',
  ljsb: 'Connection failed',
  ssz: 'Searching',
  jzz: 'Loading',
  xx: 'Messages',
  txl: 'Contacts',
  gzt: 'Workspace',
  wd: 'Mine',
  hysy: 'Welcome',
  ssjgwk: 'No results found',
  nyytxxx: 'You have a new message',
  lx: 'Offline',
  zx: 'Online',
  gly: 'Admin',
  qz: 'Group owner',
  ql: 'Group chat',
  qnc: 'Group name',
  jrsj: 'Join time',
  rqfs: 'Join method',
  swgly: 'Set as admin',
  szjy: 'Mute',
  grzl: 'Profile',
  yqjq: 'Invite to group',
  smjq: 'Scan to join',
  ssjq: 'Search to join',
  cy: 'Members',
  qcy: 'Group members',
  gd: 'More',
  qlyz: 'Group join verification',
  qcyqx: 'Member permissions',
  zrqz: 'Transfer ownership',
  byxckqtqcyzl: 'Not allowed to view other members’ profiles',
  byxtjqcywhy: 'Not allowed to add group members as friends',
  qxjy: 'Unmute',
  zdy: 'Custom',
  wb: 'Text',
  tp: 'Image',
  sp: 'Video',
  wj: 'File',
  mp: 'My accounts',
  xxyx: 'Messages selected',
  xxjsrlb: 'Recipient list',
  qbyd: 'All read',
  yd: 'Read',
  wd_1: 'Unread',
  rwd: 'Unread users',
  cjql: 'Create group chat',
  qmsy: 'Full access',
  jrql: 'Join group chat',
  xglyhtdcyxw: 'Ask admin or team members',
  ljcj: 'Create now',
  sqjr: 'Request to join',
  n: 'You',
  sqtj: 'Request to add',
  why: 'as friend',
  yzxx: 'Verification info',
  sqly: 'Request reason',
  xzndtx: 'Select your profile picture',
  wjmm: 'Forgot password',
  mm: 'Password',
  qrmm: 'Confirm password',
  qzcqrndmm: 'Please confirm your password again',
  h: 'and',
  yyzh: 'Already have an account',
  hmyzh: 'Don’t have an account',
  ljzc: 'Register now',
  sjh: 'Mobile number',
  w: 'digits',
  zsbhsz: 'Must contain numbers',
  zm: 'letters',
  yzsjh: 'Verify mobile number',
  qsrfsd: 'Please enter sent to',
  d: 'of',
  wyzm: 'digit verification code',
  yxq: 'Validity period',
  fz: 'minutes',
  zf: 'Resend',
  yzm: 'Verification code',
  m: 'seconds',
  zwsj: 'No data',
  ewm: 'QR code',
  smewm: 'Scan QR code',
  smewmmp: 'Scan QR contact card',
  qewm: 'Group QR code',
  yh: 'User',
  xb: 'Gender',
  nc: 'Name',
  yhnc: 'Username',
  bz: 'Remark',
  xgnc: 'Edit name',
  nl: 'Age',
  sr: 'Birthday',
  yx: 'Email',
  s: 'years old',
  bm: 'Private',
  n_1: 'Female',
  n_2: 'Male',
  kq: 'Enable',
  gb: 'Disable',
  zh: 'General',
  ltjl: 'Chat history',
  tjhy: 'Add friend',
  dfyszbyxbtjwhy: 'User does not allow friend requests',
  tgs: 'Manually',
  sstj: 'Add by search',
  tjqz: 'Add group',
  ss: 'Search',
  sphy: 'Video meeting',
  txgjl: 'related records',
  r: 'people',
  hyyz: 'Friend verification',
  fxx: 'Send message',
  qmc: 'Group name',
  tx: 'Profile picture',
  qtx: 'Group profile',
  djsc: 'Click to upload',
  yq: 'Invite',
  lxryx: 'Contacts selected',
  tjqcy: 'Add group members',
  ycqcy: 'Remove group members',
  cj: 'Create',
  sddqq: 'Received requests',
  fcdqq: 'Sent requests',
  yxrhrjq: 'Allow anyone to join',
  xyfsyzxx: 'Verification required',
  qcyyq: 'Member invitation',
  qcyyqwxyz: 'Invite without verification',
  tjql: 'Add group chat',
  cjptq: 'Create normal group',
  cjgzq: 'Create work group',
  grxx: 'Personal information',
  zfxx: 'Forward message',
  jdltjl: 'Chat history between',
  zdltjl: 'Chat history in',
  zzsr: 'Typing…',
  scz: 'Uploading',
  zw: 'None',
  t: 'items',
  sjzx: 'Mobile online',
  sys: 'Scan',
  fqql: 'Start group chat',
  lz: 'Record',
  ssq: 'Search group',
  ly: 'Source',
  dr: 'people',
  cz: 'Search',
  hysz: 'Friend settings',
  szbz: 'Set remark',
  bttjgpy: 'Recommend to friends',
  jchygx: 'Remove friend',
  xgqlmc: 'Edit group name',
  wzqldnc: 'My name in the group',
  txxx: 'new messages',
  hbzf: 'Merge forward',
  dltjl: 'chat history',
  syr: 'Everyone',
  txgltjl: 'related chat records',
  wdwz: 'My location',
  ckgdxglxr: 'View more related contacts',
  ckgdxgqz: 'View more related groups',
  ckgdxgltjl: 'View more related chats',
  ckgdxgwd: 'View more related documents',
  zyqzjglykbj: 'Only owner and admins can edit',
  qgl: 'Group management',
  qyjy: 'Mute all members',
  jqyz: 'Join verification',
  qzglqzr: 'Transfer group ownership',
  qlsz: 'Group settings',
  wzbqdnc: 'My name in this group',
  zdql: 'Pin group chat',
  ckqbqcy: 'View all members',
  xttz: 'System notification',
  ksczltjl: 'Quick search chat history',
  myzd: 'Not found',
  xgnr: 'Related content',
  ltsz: 'Chat settings',
  zdlxr: 'Pin contact',
  yhjf: 'Disappearing messages',
  sjsz: 'Time settings',
  zczhfsdxx: 'Messages sent after this',
  hyydhhzxzdsjzhzdsc: 'Auto delete after read at selected time',
  yhzc: 'User registration',
  yqm: 'Invitation code',
  xt: 'Optional',
  szxx: 'Set information',
  xgmm: 'Change password',
  jmm: 'Old password',
  xmm: 'New password',
  yxz: 'Selected',
  gbsgd: 'Turn off flash',
  kqsgd: 'Turn on flash',
  dfyblrhmd: 'User is blacklisted',
  nybzgqz: 'You are no longer in this group',
  qzhglyykqqtjy: 'Owner/admin enabled mute all',
  gqzybjs: 'Group dissolved',
  gqzybfj: 'Group banned',
  nybjy: 'You are muted',
  qsrnc: 'Please enter name',
  qsryqm: 'Please enter invitation code',
  qsryzm: 'Please enter verification code',
  qsrqgg: 'Please enter group announcement',
  qsrmm: 'Please enter password',
  qqrsrmm: 'Please confirm password',
  qsrsjh: 'Please enter mobile number',
  srxx: 'Enter information',
  qsrqmc: 'Please enter group name',
  zzlsrxx: 'Type message here',
  qsrndnc: 'Please enter your name',
  wccj: 'Creation completed',
  qsryx: 'Please enter email',
  ty: 'Agree',
  jj: 'Reject',
  qr: 'Confirm',
  qclsxx: 'Clear history',
  jsql: 'Dissolve group',
  tcql: 'Leave group',
  bc: 'Save',
  fb: 'Publish',
  bj: 'Edit',
  qc: 'Clear',
  jchy: 'Remove friend',
  ddyz: 'Waiting for verification',
  yjj: 'Rejected',
  yty: 'Accepted',
  fsyzm: 'Send verification code',
  dl: 'Login',
  yzmdl: 'Login with code',
  mmdl: 'Login with password',
  sjhdl: 'Login with mobile',
  yxdl: 'Login with email',
  sjhzc: 'Register with mobile',
  yxzc: 'Register with email',
  sjhzhmm: 'Recover password via mobile',
  yxzhmm: 'Recover password via email',
  zc: 'Register',
  xg: 'Modify',
  jr: 'Enter',
  xyb: 'Next',
  yc: 'Remove',
  fssq: 'Send request',
  zd: 'Pin',
  qxzd: 'Unpin',
  bjyd: 'Mark as read',
  fs: 'Send',
  ck: 'View',
  azsh: 'Hold to talk',
  skfs: 'Release to send',
  skqx: 'Release to cancel',
  yyxx: 'Voice message',
  wjxx: 'File message',
  tpxx: 'Image message',
  spxx: 'Video message',
  mpxx: 'Account information',
  szgly: 'Set administrator',
  qgg: 'Group announcement',
  sz: 'Settings',
  nqdytcgcym: 'Are you sure you want to remove this member?',
  qkltjl: 'Clear chat history',
  sch: 'After deletion',
  jwfckchhdxx: 'You will not be able to view this conversation',
  qrqkltjlm: 'Confirm clear chat history?',
  xxmdr: 'Do not disturb messages',
  pbxx: 'Block messages',
  qtjy: 'Mute all',
  jrhmd: 'Add to blacklist',
  zf_1: 'Forward',
  fz_1: 'Copy',
  ch: 'Recall',
  dx: 'Multi-select',
  hf: 'Reply',
  sc: 'Delete',
  lxr: 'contact person',
  cylxr: 'Frequent contacts',
  xdhy: 'New friends',
  xdql: 'New group chats',
  wdhy: 'My friends',
  wdqz: 'My groups',
  sqrq: 'Request to join group',
  wdsq: 'My requests',
  ahyx: 'Select by friends',
  aqlx: 'Select by groups',
  ajgx: 'Select by structure',
  zjhh: 'Recent chats',
  wcjd: 'Created by me',
  wjrd: 'Joined by me',
  wdxx: 'My information',
  hmd: 'Blacklist',
  yy: 'Language',
  qcltjl: 'Clear chat history',
  zhsz: 'Account settings',
  gywm: 'About us',
  tcdl: 'Log out',
  sctsrz: 'Upload debug log',
  txlhmd: 'Contacts blacklist',
  wrms: 'Do not disturb mode',
  xxxtsy: 'New message sound',
  jztjwwhy: 'Disallow adding me as friend',
  wzxx: 'Location message',
  hbxx: 'Merge messages',
  zdyxx: 'Custom message',
  yyxx_1: 'Quoted message',
  bqxx: 'Emoji message',
  cg: 'Draft',
  yr: 'Someone',
  zbzcdxxlx: 'Unsupported message type',
  tzxx: 'Notification message',
  hyxx: 'Meeting message',
  yynrybch: 'Quoted content was recalled',
  yy_1: 'Voice',
  wz: 'Location',
  bq: 'Emoji',
  th: 'Call',
  d_1: 'etc.',
  chlytxx: 'Recalled a message',
  chlyt: 'Recalled one',
  fsdxx: 'sent message',
  nmyjshyl: 'You are already friends',
  ksltb: 'Start chatting',
  cjlql: 'Created a group chat',
  xglqxx: 'Updated group info',
  xglqmcw: 'Changed group name to',
  xglqgg: 'Updated group announcement',
  zrlqzg: 'Transferred ownership to',
  tclql: 'Left the group',
  yql: 'Invited',
  tcl: 'Removed',
  jrlql: 'Joined the group',
  jslql: 'Dissolved the group',
  kqlqtjy: 'Enabled mute all',
  gblqtjy: 'Disabled mute all',
  b: 'was',
  jyl: 'muted',
  qxljy: 'Unmuted',
  yhjfy: 'Disappearing message enabled',
  hqzxztsb: 'Failed to get online status',
  hqqcysb: 'Failed to get group members',
  ssxxsb: 'Failed to search messages',
  hqyhxxsb: 'Failed to get user info',
  fsyzmsb: 'Failed to send verification code',
  gzhybzc: 'Account already registered',
  zhwzc: 'Account not registered',
  mmcw: 'Incorrect password',
  lcsrdmmbyz: 'Passwords do not match',
  hq: 'Get',
  sb: 'Failed',
  yzmcwhygq: 'Verification code incorrect or expired',
  zcsb: 'Registration failed',
  dlsb: 'Login failed',
  yzsb: 'Verification failed',
  xggrxxsb: 'Failed to update profile',
  czcg: 'Operation successful',
  czsb: 'Operation failed',
  fzcg: 'Copy successful',
  fzsb: 'Copy failed',
  sssb: 'Search failed',
  fsqqcg: 'Request sent successfully',
  fsqqsb: 'Request sending failed',
  hqhhxxsb: 'Failed to get session info',
  bfxxscsb: 'Partial message deletion failed',
  nrbnwk: 'Content cannot be empty',
  cjcg: 'Created successfully',
  scsb: 'Upload failed',
  sysqewm: 'Scan group QR code',
  lkjrgq: 'Join the group now',
  sysxmdewm: 'Scan the QR code below',
  tjwwhy: 'Add me as friend',
  dqdlygq: 'Current session expired',
  qcxdl: 'Please log in again',
  ndzhyzqtsbdl: 'Account logged in on another device',
  qdyfs: 'Confirm sending',
  dmpm: 'Send this contact card?',
  fscg: 'Sent successfully',
  fssb: 'Send failed',
  yqcg: 'Invitation successful',
  yqsb: 'Invitation failed',
  qrjqzzg: 'Confirm transfer ownership to',
  yccg: 'Removed successfully',
  wsbdyxnr: 'No valid content detected',
  nyjrgq: 'You joined the group',
  qrjchygx: 'Confirm remove friend',
  xgcg: 'Modified successfully',
  xgsb: 'Modification failed',
  sccg: 'Deleted successfully',
  hqqxsbhdqllqbzc: 'Permission failed or browser unsupported',
  hqdw: 'Get location',
  hqdwsb: 'Failed to get location',
  yqx: 'Cancelled',
  lzsjtdl: 'Recording too short',
  scfmtsb: 'Failed to generate cover',
  jzsb: 'Load failed',
  jsqlh: 'After dissolving group',
  syqcyjsqhqydlx: 'Members will lose contact',
  tcqlh: 'After leaving group',
  qsrzqdsjh: 'Enter valid mobile number',
  qsrzqdyx: 'Enter valid email',
  mmgsbzq: 'Invalid password format',
  lcmmbyz: 'Passwords do not match',
  xgmmcg: 'Password changed successfully',
  qdytcdlm: 'Confirm logout?',
  qsrzqdyxzh: 'Enter valid email account',
  xs: 'hours',
  t_1: 'days',
  gg: 'just now',
  bz_1: 'this week',
  by: 'this month',
  gz: 'earlier',
  xc: 'Album',
  ps: 'Capture',
  spth: 'Video call',
  jtzw: 'Simplified Chinese',
  yw: 'English',
  zhbcz: 'Account does not exist',
  sjhyzc: 'Mobile already registered',
  zhyzc: 'Account already registered',
  czgypf: 'Too many requests',
  qshzs: 'Try again later',
  yzmcw: 'Incorrect verification code',
  yzmygq: 'Verification code expired',
  yzmcwcscgxz: 'Too many wrong attempts',
  yzmybsy: 'Code already used',
  yqmybsy: 'Invitation code used',
  yqmbcz: 'Invitation code not found',
  czxz: 'Operation restricted',
  yyth: 'Voice call',
  cswjt: 'Missed due to timeout',
  thsc: 'Call duration',
  yzqtsbcl: 'Handled on another device',
  jrsb: 'Join failed',
  fqyqsb: 'Failed to send invite',
  mkfyk: 'Microphone on',
  mkfyg: 'Microphone off',
  jt: 'Answer',
  gd_1: 'Hang up',
  ysqyk: 'Speaker on',
  ysqyg: 'Speaker off',
  ddjt: 'Waiting to connect',
  thz: 'In call',
  yqnyyth: 'Invites you to voice call',
  yqnspth: 'Invites you to video call',
  zzhjz: 'Calling',
  jrth: 'Join call',
  thjl: 'Call history',
  syth: 'All calls',
  wjth: 'Missed calls',
  hr: 'Incoming',
  hc: 'Outgoing',
  zc_1: 'TOP',
  td: 'Visit',
  dh: 'Promotion',
  tg: 'Collab.',
  zhcgt: 'Recommendation',
  tdgt: 'Store visit',
  ddgt: 'Promotion',
  jcqxsb: 'Permission check failed',
  qqqxsb: 'Permission request failed',
  jrgxjc: 'Checking updates',
  xbbxx: 'New version info',
  xbb: 'New version',
  jbb: 'Old version',
  yyxzjxz: 'Download in progress',
  hlbccf: 'Ignore this trigger',
  xzwc: 'Download completed',
  yzbhgx: 'Ready to update',
  xzsb: 'Download failed',
  bbyz: 'Version identical',
  wxgx: 'No update required',
  jcbbcc: 'Version check failed',
  dy: 'Invoke',
  apgx: 'Schedule update',
  yygx: 'App update',
  jhgxsb: 'Update activation failed',
  wdtg: 'My campaigns',
  wdsc: 'My favorites',
  wdmp: 'My accounts',
  tjmp: 'Add account',
  wddz: 'My addresses',
  tjdz: 'Add address',
  tgq: 'Coupons',
  gzlb: 'Following list',
  gmjl: 'Purchase history',
  gmtgq: 'Buy campaign coupons',
  zj: 'Activity history',
  tgzzy: 'Campaign owner homepage',
  tgzrz: 'Campaign owner verification',
  bm_1: 'Apply',
  xtxx: 'System messages',
  drgc: 'Creator marketplace',
  sh: 'Review',
  gzsc: 'Follow & favorites',
  tgbm: 'Campaign application',
  xq: 'Details',
  tbsc: 'Shop',
  dhxq: 'Redemption details',
  qb: 'Wallet',
  cz_1: 'Recharge',
  tx_1: 'Withdraw',
  txmx: 'Withdrawal details',
  mx: 'Details',
  wdyhk: 'My bank cards',
  tjyhk: 'Add bank card',
  lx_1: 'Contact',
  fbtg: 'Publish campaign',
  tgxq: 'Campaign details',
  sccg_1: 'Upload draft',
  ptlj: 'Platform link',
  jb: 'Report',
  bmlb: 'Application list',
  sxbz: 'Filter creators',
  zdydq: 'Custom region',
  ssgg: 'Search announcements',
  bmcg: 'Application successful',
  tjbjlj: 'Submit post link',
  pj: 'Review',
  ykyh: 'Guest user',
  mt: 'Tomorrow',
  zt: 'Yesterday',
  n_3: 'Year',
  y: 'Month',
  r_1: 'Day',
  xhs: 'Xiaohongshu',
  dy_1: 'Douyin',
  jd: 'Enter',
  wlcw: 'Network error',
  wlcwqshzs: 'Network error. Please try again later.',
  ndyebzqcz: 'Your balance is insufficient. Please recharge.',
  qshzs_1: 'Please try again later',
  dlygq: 'Session expired',
  yebz: 'Insufficient balance',
  ndyebz: 'Your balance is insufficient',
  qcz: 'Please recharge',
  qcz_1: 'Go to recharge',
  xczs: 'Maybe later',
  qqsb: 'Request failed',
  bq_1: 'Tag',
  bmdr: 'Applicants',
  rbm: 'people applied',
  ckbm: 'View applications',
  lxfs: 'Contact info',
  bmhkj: 'Visible after applying',
  kgdr: 'Viewers',
  rll: 'views',
  tgtj: 'Campaign recommendations',
  ysc: 'Saved',
  sc_1: 'Favorite',
  fx: 'Share',
  jzsj: 'Deadline',
  fsyq: 'Follower requirements',
  tgpp: 'Promoted brand',
  zxsj: 'Execution time',
  hzxs: 'Cooperation type',
  bzyq: 'Creator requirements',
  sysjkcy: 'Scan to participate',
  bchb: 'Save poster',
  gbhb: 'Close poster',
  schb: 'Generate poster',
  sclj: 'Generate link',
  bmcj: 'Apply now',
  rsym: 'Slots full',
  meym: 'Quota full',
  ybm: 'Applied',
  ygb: 'Closed',
  gnkfz: 'Feature in development',
  dqhjbzcfz: 'Copy not supported',
  wzdhbnr: 'Poster content not found',
  zzschb: 'Generating poster',
  hbybcdwj: 'Poster saved',
  hbyxz: 'Poster downloaded',
  bchbsb: 'Failed to save poster',
  qzs: 'Please retry',
  qrgbtg: 'Confirm close campaign',
  gtgjbzbgszgc: 'Campaign will no longer be displayed',
  tgfb: 'Campaign published',
  qwfbzjf: 'Do not publish fake posts',
  dfdxjtg: 'Fake or proxy campaigns',
  jcxx: 'Basic information',
  gf: 'Fee',
  wgf: 'No fee',
  gd_2: 'Fixed',
  qj: 'Range',
  qsrgfjztbs: 'Enter coin value',
  qsrgfjztbzdz: 'Enter minimum value',
  qsrgfjztbzgz: 'Enter maximum value',
  hzfl: 'Collaboration benefits',
  zp: 'Gift',
  wzp: 'No gift',
  yzp: 'With gift',
  zpms: 'Gift description',
  qsrzpms: 'Enter gift description',
  zptbjz: 'Gift coin value',
  qsrzptbjz: 'Enter gift value',
  yjsymb: 'Use template',
  bzlx: 'Creator type',
  qxzbzlx: 'Please select creator type',
  tgwa: 'Copy',
  qxztgwa: 'Please select copy',
  wyydbty: 'I agree',
  tgfwxy: 'Service agreement',
  yl: 'Preview',
  bt: 'Title',
  qsrbhcpm: 'Enter product name',
  tdcsmdbt: 'Title with city name',
  pt: 'Platform',
  dhxs: 'Promotion format',
  zbdh: 'Live selling',
  twgc: 'Image post with link',
  spgc: 'Video post with link',
  bx: 'Unlimited',
  sptbjz: 'Product coin value',
  tgf: 'Campaign fee',
  tb: 'Coins',
  hzyjtbjz: 'Commission coin value',
  yb: 'Postal code',
  szsf: 'Province',
  szcs: 'City',
  ppmc: 'Brand name',
  xqme: 'Required slots',
  qsrzzs: 'Enter positive integer',
  twsp: 'Image & video',
  tw: 'Image',
  dphj: 'Single product collection',
  dp: 'Single product',
  hj: 'Collection',
  jzrq: 'Registration deadline',
  qxzjzrq: 'Select registration deadline',
  fbyy: 'Publish language',
  qzxfbyy: 'Select publish language',
  yjhgbfdwk:
    'Commission and manuscript fee cannot both be empty; fill at least one',
  rwmjzrq: 'Task deadline',
  xzrwmjzrq: 'Select task deadline',
  rwmjzbnzybmjzrq:
    'Task deadline cannot be earlier than the registration deadline',
  qsrcpjs: 'Enter product description',
  sycj: 'Usage scenario',
  bzdhsjyqd: 'Creator performance requirements',
  xh: 'Personal care',
  qc_1: 'Automotive',
  sp_1: 'Food',
  cd: 'Fashion',
  yxdm: 'Games & anime',
  cw: 'Pets',
  mz: 'Beauty',
  kjsm: 'Tech & digital',
  ys: 'Wellness',
  ydcw: 'Sports & lifestyle',
  qt: 'Others',
  gxcg: 'Update successful',
  ddhtsh: 'Waiting for approval',
  qzyckxx: 'Please check messages',
  qsrzqdgf: 'Enter correct fee',
  qsrzqdjgqj: 'Enter correct price range',
  gfzdzyxygfzgz: 'Min must be less than max',
  qsrzqdzpjz: 'Enter correct gift value',
  zpjzbnxy: 'Value cannot be lower',
  whz: 'Not collaborated',
  qsrssgjc: 'Search',
  jxz: 'In progress',
  dsg: 'Pending review',
  dfb: 'Pending publish',
  ywc: 'Completed',
  j: 'Old',
  x_1: 'New',
  tgyx: 'Campaign priority',
  lyl: 'Chat',
  ddtgzty: 'Waiting for advertiser approval',
  bzsj: 'Creator view',
  wbm: 'Not applied',
  dsgds: 'All pending review',
  wlx: 'Not contacted',
  ylxdwqr: 'Contacted but not confirmed',
  yqrhz: 'Cooperation confirmed',
  yjjhz: 'Cooperation rejected',
  an: 'Button',
  yhzd: 'Collaborated',
  xccg: 'Upload draft first',
  ytjcghybhd: 'Draft submitted or rejected',
  xgcg_1: 'Edit draft',
  ckbj: 'View post',
  yshtg: 'Approve',
  tjbj: 'Submit post',
  yfk: 'Paid',
  ypj: 'Reviewed',
  tgz: 'Campaign owner',
  shz: 'Under review',
  shybh: 'Review rejected',
  ftgxx: 'Send campaign message',
  gbtg: 'Close campaign',
  qbm: 'Apply now',
  wgs: 'Not approved',
  sytgq: 'Remaining coupons',
  zm_1: 'Recruit',
  bz_2: 'Creator',
  qh: 'Switch',
  lz_1: 'From',
  fs_1: 'Followers',
  fy: 'Note',
  tjgdmp: 'Add more accounts',
  sjdz: 'Shipping address',
  qxzsjdz: 'Select address',
  yhzh: 'Bank account',
  qxzyhzh: 'Select bank account',
  cjbm: 'Super application',
  qxzyptyzdmp: 'Select matching account',
  fslbdbhsbm: 'Follower count does not meet the requirement',
  qsrbt: 'Enter title',
  qzzlsrzw: 'Enter content here',
  cgyl: 'Draft preview',
  bhcg: 'Reject draft',
  shtg: 'Approve',
  fhxg: 'Return to edit',
  qrsc: 'Confirm upload',
  bh: 'Reject',
  bhyy: 'Rejection reason',
  qsrbhyy: 'Enter rejection reason',
  ylcg: 'Preview draft',
  qtxbthzw: 'Fill title or content',
  sccg_2: 'Upload successful',
  cgysc: 'Draft uploaded',
  qzstjzw: 'Add content',
  tphsp: 'Image or video',
  qsrzsydzw: 'Enter at least one paragraph',
  qzsscyztphsp: 'Upload at least one media',
  qzsscyztp: 'Please upload at least one image',
  qrtgggjm: 'Confirm approval?',
  tgcg: 'Approved successfully',
  cgytg: 'Draft approved',
  cgbh: 'Draft rejected',
  cgybh: 'Draft rejected',
  c: 'times',
  pf: 'Rating',
  me: 'Slots',
  ylwz: 'Reserved slot',
  zctgkyzzlzs: 'Recommendation campaigns shown here',
  tgbh: 'Campaign ID',
  nrxs: 'Content format',
  dq: 'Region',
  zpfl: 'Gift benefits',
  zpjz: 'Gift value',
  hzyj: 'Commission',
  qbpt: 'Platforms',
  fssl: 'Followers',
  qbfl: 'Categories',
  zz: 'Reset',
  zwtg: 'No campaigns',
  ys_1: 'Above',
  ysdbjlsk: 'Distance to viewport',
  xdzt: 'Sticky state',
  nha: 'Hello',
  fsyq_1: 'Send invitation',
  qlmc: 'Group name',
  ls: 'Li Si',
  wsbz: 'I am creator',
  hdh: 'If OK',
  srxx_1: 'Enter message',
  jyz: 'Muted',
  sdsmb: 'Say something',
  yfb: 'Published',
  yhs: 'Suitable',
  ytjcg: 'Draft submitted',
  yxgtj: 'Edited & submitted',
  shytg: 'Review approved',
  ytjbj: 'Post submitted',
  bzypj: 'Creator reviewed',
  tgzwpj: 'Owner not reviewed',
  tgzypj: 'Owner reviewed',
  bzwpj: 'Creator not reviewed',
  nyfk: 'You have paid',
  qggpjb: 'Please leave a review',
  tglcxx: 'Campaign workflow message',
  sggl: 'Review draft',
  lglglllsgg: 'Draft already approved',
  sg: 'Review the draft',
  cgyjtgl: 'The draft has already been approved',
  wxcfsg: 'No need to review again',
  fk: 'Payment',
  nyjfgkl: 'You have already paid',
  wxcffk: 'No need to pay again',
  dqzfxxh: 'This payment will consume',
  tbzh: 'Coin equivalent',
  oy: 'Euro',
  sfjx: 'Do you want to continue?',
  fkcg: 'Payment successful',
  nyjpjgl: 'You have already reviewed',
  tgywc: 'The campaign is completed',
  wfpj: 'Cannot review',
  tjcg_1: 'Submit the draft',
  wxcftjcg: 'No need to resubmit post',
  fbbj: 'Campaign ended',
  rwjzrqygwfbm:
    'The task deadline has passed; registration is no longer available.',
  wxcftjbj: 'Draft uploaded',
  tgyjs: 'The campaign has ended',
  ysccg: 'Draft uploaded',
  yj: 'Commission',
  jz: 'Value',
  hs: 'Suitable',
  bhs: 'Not suitable',
  wfl: 'No benefits',
  dtjcg: 'Draft pending submission',
  dtjbj: 'Post pending submission',
  dfk: 'Pending payment',
  sdxx: 'Message received',
  xxnr: 'Message content',
  zxxxsj: 'Latest message time',
  zxxx: 'Latest message',
  qjcfw: 'Please check the service',
  ljcg: 'Connection successful',
  fwljsb: 'Service connection failed',
  ljgb: 'Connection closed',
  fscw: 'An error occurred',
  llqjdxxx: 'Browser received a new message',
  khdzdgb: 'Client closed the connection',
  llqfcxx: 'Browser sent a message',
  fwxycs: 'Service response timeout',
  ljcw: 'Connection error',
  fsfs_1: 'Send failed',
  fsfs_timeout: 'Message send timeout, please try again later',
  fsfs_nosocket: 'Connection not initialized, send failed',
  fsfs_connect_timeout: 'Connection timed out, send failed',
  fsfs_connect_error: 'Connection error, send failed',
  fsfs_connect_closed: 'Connection closed, send failed',
  fsfs_send_error: 'Message send failed, please try again later',
  fsfs_disconnect: 'Connection lost, message send failed',
  jt_1: 'Today',
  sz_1: 'Last week',
  nh: 'Hello',
  ysmkybndm: 'How can I help you?',
  qxx: 'Group messages',
  xxls: 'Message history',
  yxx: 'Original message',
  q: 'Group',
  fm: 'Cover',
  wdsl: 'Unread count',
  nmtjbchz: 'Submit collaboration anonymously',
  hscpjks: 'Good things start with reviews',
  tj_1: 'Submit',
  shpj: 'Review later',
  qgcpfhpjnr: 'Please rate and comment',
  ytjpj: 'Review submitted',
  ldk: 'Check in',
  dksb: 'Check-in failed',
  dkcg: 'Check-in successful',
  xlsxcs: 'Pull refresh test',
  wsydxd: 'I have limits',
  dw: 'Tap me',
  wszcymfhdsj: 'Recommendation page data',
  ndzsyqm: 'Your exclusive invite code',
  fzyqm: 'Copy invite code',
  jyjtfxhtjgpyss: 'Share screenshot or recommend',
  bcewm: 'Save QR code',
  fzfxlj: 'Copy share link',
  msfx: 'Share now',
  ggdl: 'Google login',
  xm: 'Project',
  nh_1: 'Hello',
  qxzndjs: 'Select your role',
  wstgz: 'I am an advertiser',
  yhyx: 'User email',
  yzmyfs: 'Code sent',
  qcs: 'Please check',
  hqyzm: 'Get verification code',
  hcxhq: 'Get again later',
  qsrzqyx: 'Enter valid email',
  ccl: 'Something went wrong',
  qsctx: 'Upload a profile picture',
  xby: 'Spain',
  gj: 'Country',
  xzgj: 'Select country',
  zg: 'China',
  tgfwh: 'Service account',
  z: 'Like',
  tj_2: 'Recommend',
  ly_1: 'Comment',
  rhhqxhslj: 'How to get Xiaohongshu link',
  rhhqdylj: 'How to get Douyin link',
  rhhq: 'How to get',
  lj: 'Link',
  dyb: 'Step 1',
  deb: 'Step 2',
  dsb: 'Step 3',
  dsib: 'Step 4',
  gz_1: 'Follow',
  jrybmcs: 'Today applications',
  yxqz: 'Valid until',
  qxf: 'Renew',
  ndvipjrdqqjsxf: 'Your VIP expires today. Please renew in time.',
  ckviptc: 'View VIP plans',
  jrtclj: 'Go to package',
  kthyk: 'Activate membership',
  tyvip: 'Trial VIP',
  tygjtq: 'Experience benefits',
  kt: 'Activate',
  tbye: 'Coin balance',
  djstb: 'Pending coins',
  ljjstb: 'Total settled coins',
  dhsc: 'Redemption store',
  wdqb: 'My wallet',
  yhk: 'Bank card',
  dz: 'Address',
  qb_1: 'All',
  kbm: 'Available',
  afbsj: 'By publish time',
  ygq: 'Expired',
  qxgz: 'Unfollow',
  zwgz: 'No follows',
  sfqxgzgtgz: 'Unfollow this owner?',
  bzgz: 'Stop following',
  jxgz: 'Continue following',
  wdzj: 'My activity',
  qy: 'Benefits',
  tz: 'Notifications',
  wdzy: 'My homepage',
  tgzkk: 'Owner card activation',
  hqtgzk: 'Get owner card',
  qkk: 'Activate',
  zdwdtg: 'Pin my campaign',
  ppf: 'Brand',
  dyygs: 'Agency',
  gr: 'Individual',
  ds: 'E-commerce',
  rzz: 'Verifying',
  rzsb: 'Verification failed',
  wrztgz: 'Unverified owner',
  qxzgj: 'Select country',
  sjr: 'Recipient',
  qsryb: 'Enter postal code',
  xxdz: 'Detailed address',
  cs: 'City',
  xzcs: 'Select city',
  swmr: 'Set as default',
  bjdz: 'Edit address',
  zxq: 'Municipality',
  mr: 'Default',
  nhmytjdz: 'No address added',
  qtj: 'Add now',
  mpxx_1: 'Card information',
  qxzpt: 'Select platform',
  mppt: 'Account platform',
  djqhpt: 'Switch platform',
  qtx_1: 'Please fill',
  xts: 'Tips',
  dyfzdljxysdqmwzbf: 'Remove prefix text',
  ljznl: 'Where is the link',
  hzbj: 'Cooperation quote',
  sdzbj: 'Self quote',
  hzfs: 'Cooperation method',
  txhzfs: 'Fill cooperation method',
  khzdrly: 'Collaboration fields',
  lybq: 'Field tags',
  qxzlybq: 'Select tags',
  zd_1: 'Maximum',
  g: 'items',
  zhjt: 'Account screenshot',
  qsczhjt: 'Upload screenshot',
  scd: 'Uploaded',
  ymjtbxsdqmpdydzh: 'Must match account',
  qwbscnbrdzh: 'Upload your own account',
  qqbjtqxwzl: 'Ensure clear screenshot',
  xxwz: 'Complete information',
  bhtx: 'Includes profile',
  fss: 'Followers count',
  dzsdgjxx: 'Likes and key info',
  tjrz: 'Submit verification',
  gly_1: 'fields',
  mpxq: 'Account details',
  gxsj: 'Update time',
  sdgx: 'Manual update',
  zy: 'Homepage',
  dz_1: 'Like',
  kdzbj: 'Custom quote',
  sxly: 'Selected fields',
  ptpphzrdxtwb: 'Optional text',
  yjzs: 'Show if exists',
  mxjbzs: 'Hide if empty',
  swbmmr: 'Set default',
  bjmp: 'Edit account',
  sjzbj: 'Merchant quote',
  ptpphzrd: 'Brand partners',
  scmp: 'Delete account',
  qsrlybq: 'Enter tags',
  qryscbq: 'Confirm delete tag',
  mplb: 'List of accounts',
  nhmytjmp: 'No accounts added',
  rzytg: 'Verification approved',
  rzybh: 'Verification rejected',
  wrz: 'Not verified',
  dsh: 'Pending review',
  qxzshtgdmp: 'Select approved account',
  cxsh: 'Resubmit for review',
  fhyzdznylzmp: 'Non-members max two accounts',
  sfyqmhy: 'Buy membership?',
  qmhyy: 'Go to membership page',
  xzpt: 'Select platform',
  tbggtx: 'Sync Google profile',
  tbcg: 'Sync successful',
  ytbggtx: 'Google profile synced',
  gh: 'Change',
  xrsc: 'New user guide',
  lxkf: 'Contact support',
  tkgz: 'Terms & rules',
  wx: 'WeChat',
  nhsy: 'Remaining',
  ztgq: 'coupons',
  z_1: 'pieces',
  lkgm: 'Buy now',
  tgqgmxy: 'Coupon agreement',
  q_1: 'coupon',
  qhq: 'Get',
  lx_2: 'Type',
  zwgmjl: 'No purchase history',
  tgqgmjl: 'Coupon purchase history',
  ygm: 'Purchased',
  shwtg: 'Review failed',
  ytg: 'Approved',
  tbjs: 'Coin settlement',
  nsqd: 'Your request',
  jszzshz: 'Settlement under review',
  qnxdd: 'Please wait',
  yjjswc: 'Calculation completed',
  zwxx: 'No messages',
  shsj: 'Review time',
  hd: 'OK',
  hg: 'Follow back',
  zwxxx: 'No new messages',
  drgcxx: 'Creator hub messages',
  h_1: 'No.',
  zlzszxytxx: 'Latest message shown here',
  jj_1: 'Only',
  lt: 'Chat',
  qkdltjljwfhf: 'Cleared chats cannot be recovered',
  qjscz: 'Please proceed carefully',
  qrqk: 'Confirm clear',
  zzqk: 'Clearing',
  ltjlyqk: 'Chat history cleared',
  jl: 'Guerlain',
  zwhd: 'No activities',
  xhdbt: 'New activity title',
  zlzsxhdjjdfzxwa: 'Activity description text',
  sgjbxbptgdhdbt: 'Promotion campaign title',
  zlzshdjjdfzxwa: 'Activity intro text',
  glytz: 'Admin notice',
  fssj: 'Send time',
  qdyc: 'Confirm removal',
  m_1: '?',
  sjhcdbzq: 'Invalid phone length',
  xy: 'Agreement',
  lxdh: 'Phone',
  lxyx: 'Contact email',
  bd: 'Bind',
  bbh: 'Version',
  qdytcm: 'Confirm exit?',
  tc: 'Exit',
  xz_1: 'Add new',
  qxzs: 'Select province',
  s_1: 'City',
  q_2: 'District',
  zjs: 'Zhejiang Province',
  s_2: 'Province',
  ws: 'I am',
  rzzn: 'Verification guide',
  ptbhgkyhysxx: 'Platform protects privacy',
  jxyyzsf: 'For identity verification only',
  zzrz: 'Qualification verification',
  sfrz: 'Identity verification',
  sbzcz: 'Trademark certificate',
  yyzz: 'Business license',
  ppm: 'Brand name',
  gsqc: 'Company full name',
  hy: 'Industry',
  ly_2: 'Field',
  qywx: 'WeCom',
  ddgrzly: 'DingTalk profile',
  zzzm: 'Employment certificate',
  xbhxm: 'Must include name',
  gsmhzw: 'Company & position',
  zzzmxjgsqzthsgz: 'Official stamp required',
  bzc: 'Not supported',
  z_2: 'Stamp',
  dzz: 'Electronic stamp',
  bmzjzyz: 'Department stamp',
  xm_1: 'Name',
  sfzh: 'ID number',
  mysfz: 'No ID',
  kglybzly: 'Admin remark allowed',
  wcnyszlzskx: 'I confirm info is true',
  dphtjt: 'Store backend screenshot',
  dpwljt: 'Logistics screenshot',
  dpmc: 'Store name',
  dplj: 'Store link',
  yzxgflfg: 'According to regulations',
  qxyzsf: 'Verify identity first',
  sqrz: 'Apply verification',
  nyjs: 'You already are',
  rztgz: 'Verified campaign owner',
  nytjrzsq: 'Verification submitted',
  qddsh: 'Await review',
  shbjj: 'Review rejected',
  rgnytgzjgsdcp: 'Promote own company',
  rgnszdgsxytgqtgsdcp: 'Company promotes others',
  rgnsygrmytgqtgsdcp: 'Personal promotion',
  rgnstb: 'If Taobao seller',
  tm: 'Tmall',
  jdddssj: 'JD e-commerce',
  xtgzjdpdcp: 'Promote own products',
  yppfgtjl: 'Brand communication record',
  xzsqsmb: 'Download authorization template',
  pptfsq: 'Brand authorization',
  ht: 'Contract',
  xjgsqzthsgz: 'Official stamp required',
  sqgsqc: 'Authorized company name',
  qxlh: 'Remove blacklist',
  ygz: 'Followed',
  qrqxlhgtgz: 'Confirm unblock',
  jjxzsgtgzdtg: 'Campaigns visible again',
  jxlh: 'Keep blocked',
  qxlhcg: 'Unblocked successfully',
  qrlhgtgz: 'Confirm blacklist',
  jbzzsgtgzdtg: 'Campaigns hidden',
  lh: 'Block',
  blh: 'Do not block',
  lhcg: 'Block successful',
  zx_1: 'Center',
  hjbj: 'Long time no see',
  ndhyygq: 'Membership expired',
  ljgm: 'Buy now',
  ktqyd: 'Read before activation',
  hyfwxy: 'Membership agreement',
  hyqydb: 'Benefits comparison',
  qydb: 'Comparison',
  fhy: 'Non-member',
  yfhy: 'Monthly member',
  j_1: 'Only',
  jfhy: 'Quarterly member',
  nfhy: 'Yearly member',
  mrjstgsx: 'Daily unlock limit',
  wx_1: 'Unlimited',
  mrkbmsx: 'Daily apply limit',
  gjrw: 'High-value tasks',
  xlrw: 'Limited tasks',
  rwtjsfyx: 'Priority algorithm',
  yxppgzhrw: 'High conversion priority',
  rwss: 'Task search',
  dy_2: 'Subscribe',
  zcgjc: 'Keyword support',
  hyfl: 'Industry category',
  mggty: 'Ad-free experience',
  dsjzhbd: 'Multi account binding',
  r_2: 'Such as',
  zskfzc: 'Dedicated support',
  xszc: 'Hourly support',
  rwshyxcl: 'Priority review',
  rw: 'Task',
  xsnsh: 'Reviewed within hours',
  hyjfjlfb: 'Double points',
  zshz: 'Exclusive badge',
  rwtgtsbg: 'Boost exposure',
  yxtj: 'Priority recommendation',
  zp_1: 'Works',
  qxtyhyfwxy: 'Agree to terms first',
  qxzygmdhyfa: 'Choose membership plan',
  wxts: 'Reminder',
  byebz: 'Insufficient balance',
  qdyqczm: 'Go recharge?',
  tjxk: 'Add new card',
  yhxx: 'Bank info',
  m_2: 'First name',
  qsrm: 'Enter first name',
  xs_1: 'Last name',
  qsrxs: 'Enter last name',
  kh: 'Card number',
  qsrkh: 'Enter card number',
  sxrq: 'Expiry date',
  qsrrq: 'Enter date',
  qsrsjrxm: 'Enter recipient',
  qsrdz: 'Enter address',
  qxzcs: 'Select city',
  wsdk: 'Mastercard',
  zgyh: 'Bank of China',
  cxk: 'Debit card',
  payh: 'Ping An Bank',
  hxyh: 'Huaxia Bank',
  qdysczzyhkm: 'Delete bank card?',
  sr_1: 'Income',
  zc_2: 'Expense',
  zd_2: 'Bill',
  wdye: 'My balance',
  djje_1: 'Frozen limit',
  djmx: 'Freeze details',
  ckmx: 'View details',
  djsj: 'Freeze time',
  djje: 'Frozen amount',
  tgmc: 'Campaign name',
  txed: 'Withdrawal amount',
  kydh: 'Redeemable',
  yhkh: 'Bank card number',
  txxx_1: 'Withdrawal info',
  yhkszgj: 'Bank country',
  yhmc: 'Bank name',
  zhcyrxm: 'Account holder',
  dm: 'Code',
  tkje: 'Withdrawal amount',
  zt_1: 'Status',
  shbh: 'Rejected',
  sxf: 'Fee',
  jx: 'Continue',
  czcg_1: 'Recharge successful',
  jxcz: 'Continue recharge',
  wc: 'Finish',
  czfs: 'Recharge method',
  qxzyhk: 'Select bank card',
  dcjyesx: 'Transaction limit',
  czje: 'Recharge amount',
  yxsrsz: 'Numbers only',
  dqdfhdcszjp: 'Numeric keyboard',
  qsrje: 'Enter amount',
  xe: 'Limit',
  dqzhtbye: 'Current coin balance',
  ljcz: 'Recharge now',
  pfyh: 'SPD Bank',
  zsyh: 'CMB',
  qsrczje: 'Enter recharge amount',
  yhdhk: 'Bank transfer',
  qxzyhszgj: 'Select bank country',
  yhszgj: 'Bank country',
  qtxyhmc: 'Enter bank name',
  qsryhmc: 'Enter bank name',
  yhfhdz: 'Branch address',
  qsryhfhdz: 'Enter branch address',
  qtxzhcyrxm: 'Enter account holder',
  qsrzhcyrxm: 'Enter account holder',
  gjyhzh: 'IBAN',
  qsrtkje: 'Enter withdrawal amount',
  xyxh: 'Will consume',
  txsqytj: 'Withdrawal submitted',
  hdmc: 'Activity name',
  ye: 'Balance',
  jbcttg: 'Report this ad',
  xzjbly: 'Select reason',
  jbyy: 'Report reason',
  txjbyy: 'Enter reason',
  jbcg: 'Report successful',
  szh: 'After setting',
  xthzdsxfhyqdbmbz: 'System auto filters creators',
  drly: 'Creator field',
  qg: 'Nationwide',
  wctgrw: 'Complete campaign',
  fh: 'Back',
  jxlnky: 'Next you can',
  qsrwz: 'Enter URL',
  bjtjcg: 'Post submitted',
  bjytj: 'Post submitted',
  yhz: 'Collaborated',
  ygs: 'Approved',
  dpj: 'Pending review',
  yjtbjz: 'Commission value',
  bj_1: 'Post',
  fkpz: 'Payment proof',
  kzybmlbplcz: 'Batch operation available',
  qbhs: 'All suitable',
  fzmdlj: 'Copy list link',
  zwkf: 'Not available yet',
  dqmykyplczdsj: 'No batch data',
  plcz: 'Batch operation',
  qdyzxcczm: 'Confirm operation?',
  dzsl: 'Likes count',
  scsl: 'Favorites count',
  ysx: 'Filtered',
  qytgzqrhz: 'Confirm cooperation',
  qddtgztyhz: 'Please wait for the advertiser to approve the cooperation',
  ytgzlyl: 'Chat with owner',
  ddsjxx: 'Waiting merchant message',
  sjhzdlxhsrx: 'Merchant will contact',
  sdcpcl: 'Received materials',
  cp: 'Product',
  ayqfbjhsp: 'Post as required',
  fsjbjlj: 'Send post link',
  lqgf: 'Receive payment',
  gzgzh: 'Follow official account',
  jsjstx: 'Receive reminders',
  spxq: 'Product details',
  kytbs: 'Available coins',
  ljdh: 'Redeem now',
  xzdhsl: 'Select quantity',
  dh_1: 'Redeem',
  qxzdhsl: 'Select quantity',
  dhcg: 'Redeem successful',
  sy: 'Remaining',
  dhjl: 'Redemption history',
  xx_1: 'Xiao Xiao',
  bggcdl: 'Bai just won',
  cdl: 'Won',
  jfcjgz: 'Points lottery rules',
  jfdhsp: 'Points redemption products',
  qdh: 'Go redeem',
  zwsp: 'No products',
  xxcy: 'Thanks for participating',
  dhsj: 'Redemption time',
  ddbh: 'Order number',
  dhsl: 'Redemption quantity',
  sf: 'Actual payment',
  zwdhsj: 'No redemption data',
  cj_1: 'Lottery',
  zjsj: 'Winning time',
  tbjz: 'Coin value',
  zwcjsj: 'No lottery data',
  gxzj: 'Congratulations',
  hyhwzj: 'Not a winner',
  yzlycm: 'Try again?',
  kxsx: 'Accept happily',
  yy_zh: 'ZH',
  yy_en: 'EN',
  yy_sp: 'ES',
  sys_msg_type_101: 'Advertiser verification approved',
  sys_msg_type_102: 'Advertiser verification rejected',
  sys_msg_type_103: 'Coin settlement review',
  sys_msg_type_104: 'Review pending',
  sys_msg_type_105: 'Profile card approved',
  sys_msg_type_106: 'Profile card rejected',
  sys_msg_type_107: 'Announcement approved',
  sys_msg_type_108: 'Announcement rejected',
  sys_msg_type_109: 'Withdrawal approved',
  sys_msg_type_110: 'Withdrawal rejected',
  sys_msg_type_111: 'Withdrawal under review',
  sys_msg_type_201: 'Creator signed up',
  sys_msg_type_202: 'Mark suitable',
  sys_msg_type_203: 'Registration declined',
  sys_msg_type_204: 'Quota full',
  sys_msg_type_301: 'New follower / follow notification',
  sys_msg_type_302: 'Announcement favorited',
  sys_msg_type_401: 'System notice',
  sys_msg_type_402: 'Campaign notice',
  sys_msg_type_403: 'Warning notice',
  sys_msg_reason_none: 'None',
  sys_msg_unknown_user: 'Unknown user',
  sys_msg_unknown_announcement: 'Unknown announcement',
  sys_msg_content_101:
    'Congratulations! Your advertiser verification application has been approved.',
  sys_msg_content_102_plain:
    'We are sorry, your advertiser verification application was not approved.',
  sys_msg_content_102_reason:
    'We are sorry, your advertiser verification application was not approved. Reason: {reason}',
  sys_msg_content_104_reviewing:
    'Your announcement "{name}" is under review.',
  sys_msg_content_104_pending:
    'Your announcement "{name}" is pending review.',
  sys_msg_content_105:
    'Your {platform} profile card has been approved.',
  sys_msg_content_106:
    'Your {platform} profile card was not approved. Reason: {reason}',
  sys_msg_content_107: 'Your announcement "{name}" has been approved.',
  sys_msg_content_108_no_reason:
    'Your announcement "{name}" was not approved.',
  sys_msg_content_108_with_reason:
    'Your announcement "{name}" was not approved. Reason: {reason}',
  sys_msg_content_109:
    'Your withdrawal request (amount: {amount} EUR) has been approved and is expected to arrive within 3 business days.',
  sys_msg_content_110:
    'Your withdrawal request (amount: {amount} EUR) was not approved. Reason: {reason}',
  sys_msg_content_111:
    'Your withdrawal request (amount: {amount} EUR) is under review. Please wait patiently.',
  sys_msg_content_201:
    'Creator {nickname} signed up for your announcement: {title}',
  sys_msg_content_204:
    'All suitable slots for "{name}" are full. Thank you for signing up.',
  sys_msg_content_301: 'User {operatorNickname} followed you.',
  sys_msg_content_302:
    'User {operatorNickname} favorited your announcement {activityName}',
  'advertiser.announcement_register_business_card_required':
    'No business card created',
  'advertiser.announcement_register_business_card_pending':
    'Business card under review',
  'advertiser.announcement_register_business_card_rejected':
    'Business card review not passed',
  'advertiser.announcement_register_business_card_fetch_failed':
    'Failed to fetch business card',
  'global.success': 'Success',
  'global.bad_request': 'Invalid request parameters',
  'global.unauthorized': 'Not logged in',
  'global.forbidden': 'No permission for this operation',
  'global.not_found': 'Request not found',
  'global.method_not_allowed': 'Invalid HTTP method',
  'global.locked': 'Request failed, please try again later',
  'global.too_many_requests': 'Too many requests, please try again later',
  'global.internal_server_error': 'System error',
  'global.not_implemented': 'Feature not implemented or disabled',
  'global.error_configuration': 'Invalid configuration',
  'global.repeated_requests': 'Duplicate request, please try again later',
  'global.demo_deny': 'Demo mode: write operations are disabled',
  'global.unknown': 'Unknown error',
  flow: {
    advertiser_draft_approved:
      'Your draft was approved. Please publish your note.',
    advertiser_draft_rejected:
      'Your draft was rejected. Please revise and resubmit.',
    advertiser_evaluation:
      'The advertiser has completed their review.',
    advertiser_payment:
      'The advertiser has completed payment. Thank you for collaborating.',
    advertiser_suitable:
      'The advertiser thinks you are a good fit. Please upload your draft.',
    advertiser_unsuitable:
      'The advertiser does not think it is a good fit. Thank you for participating.',
    influencer_evaluation:
      'The creator has completed their review. Thank you for working together.',
    influencer_submit_note:
      'The creator has submitted the note. Please review and confirm.',
    influencer_upload_draft:
      'The creator has uploaded a draft. Please review it in time.',
  },
};
